import * as Inovx from '@shared';
import { apiPostFormUrlEncoded, apiPostJson, FormUrlEncodedBody } from '@shared/api/apiClient';
var UrlUtilities = Inovx.Shared.Common.UrlUtilities;
var url = `${UrlUtilities.getApiUrl()}/FacilityApi/api/AssetSet`;
const pendingFacilityAssetSets = new Map<string, Promise<IAssetSet[]>>();

interface AssetSetRequestOptions {
    suppressGlobalError?: boolean;
}

export interface AssetSetAssetObjectChildrenBatchItem {
    AssetSetID: string;
    VersionToken?: string | null;
    AssetObjectIDs: string[];
}

interface AssetSetAssetObjectChildrenBatchResult {
    AssetSets: AssetSetAssetObjectChildrenBatchItem[];
}

const AssetSetsServices = { ...Inovx.Shared.Flux.BaseService,
   
    createAssetSet: function (assetSetData: any, options?: AssetSetRequestOptions) {
        return new Promise<IAssetSet>((resolve, reject) => {
            apiPostFormUrlEncoded<IAssetSet>(url + "/Create", assetSetData as FormUrlEncodedBody, { responseType: 'json' })
                .then((result: IAssetSet) => {
                    resolve(result);
                })
                .catch((error: any) => {
                    if (!options?.suppressGlobalError) {
                        this.handleWebApiError(error);
                    }
                    reject(error);
                });

        });
    },
    updateAssetSet: function (assetSetData: any, options?: AssetSetRequestOptions) {
        return new Promise<IAssetSet>((resolve, reject) => {
            apiPostFormUrlEncoded<IAssetSet>(url + "/Update", assetSetData as FormUrlEncodedBody, { responseType: 'json' })
                .then((result: IAssetSet) => {
                    resolve(result);
                })
                .catch((error: any) => {
                    if (!options?.suppressGlobalError) {
                        this.handleWebApiError(error);
                    }
                    reject(error);
                });

        });
    },
    getAssetSets: function (knowledgeBookID: string) {
        return new Promise<IAssetSet[]>((resolve, reject) => {
            this.get(`${url}/ByKnowledgeBook`,
                { knowledgeBookID: knowledgeBookID },
                (retData: IAssetSet[]) => {
                    resolve(retData)
                },
                (error: IServiceErrorObject) => {
                    this.handleWebApiError(error);
                    reject(error);
                }
            );
        });
    },
    getAssetSetsByFacility: function (facilityID: string) {
        const pending = pendingFacilityAssetSets.get(facilityID);
        if (pending) return pending;

        const request = new Promise<IAssetSet[]>((resolve, reject) => {
            this.get(`${url}/ByFacility`,
                { facilityID },
                (retData: IAssetSet[]) => {
                    resolve(retData)
                },
                (error: IServiceErrorObject) => {
                    this.handleWebApiError(error);
                    reject(error);
                }
            );
        }).finally(() => pendingFacilityAssetSets.delete(facilityID));
        pendingFacilityAssetSets.set(facilityID, request);
        return request;
    },
    deleteAssetSet: function (as: IAssetSet) {
        return new Promise<void>((resolve, reject) => {
            this.post(`${url}/Delete`,
                { ID: as.ID, VersionToken: as.VersionToken },
                () => {
                    resolve();
                },
                (error: IServiceErrorObject) => {
                    this.handleWebApiError(error);
                    reject(error);
                }
            );
        });
    },
    getAssetSet: function (id: string) {
        return new Promise<IAssetSet>((resolve, reject) => {
            this.get(`${url}/ById`,
                { id },
                (retData: IAssetSet) => {
                    resolve(retData)
                },
                (error: IServiceErrorObject) => {
                    this.handleWebApiError(error);
                    reject(error);
                }
            );
        });
    },
    getAssetSetDetail: function (id: string) {
        return new Promise<IAssetSet>((resolve, reject) => {
            this.get(`${url}/Detail`,
                { id },
                (retData: IAssetSet) => {
                    resolve(retData)
                },
                (error: IServiceErrorObject) => {
                    this.handleWebApiError(error);
                    reject(error);
                }
            );
        });
    },
    setAssetSetProperties: function (kv: IAssetSet) {
        return new Promise<IAssetSet>((resolve, reject) => {
            apiPostFormUrlEncoded<IAssetSet>(url + "/SetProperties", kv as FormUrlEncodedBody, { responseType: 'text' })
                .then((result: IAssetSet) => {
                    resolve(result);
                })
                .catch((error: any) => {
                    this.handleWebApiError(error);
                    reject(error);
                });

        });
    },
    getAssetObjectChildren: function (id: string) {
        return new Promise<string[]>((resolve, reject) => {
            this.get(`${url}/AssetObjectChildren`,
                { id },
                (retData: string[]) => {
                    resolve(retData);
                },
                (error: IServiceErrorObject) => {
                    this.handleWebApiError(error);
                    reject(error);
                }
            );
        });
    },
    getAssetObjectChildrenBatch: async function (facilityID: string, ontologyID: string, assetSetIDs: string[]) {
        try {
            const result = await apiPostJson<AssetSetAssetObjectChildrenBatchResult>(
                `${url}/AssetObjectChildrenBatch`,
                { FacilityID: facilityID, OntologyID: ontologyID, AssetSetIDs: assetSetIDs },
                { responseType: 'json' }
            );
            return result.AssetSets ?? [];
        } catch (error) {
            this.handleWebApiError(error);
            throw error;
        }
    },
};

export default AssetSetsServices;
